import { useEffect } from 'react'

import useReduxSelector from 'hooks/useReduxSelector'
import withRenderClientsideOnly from '../utils/withRenderClientsideOnly'
import { useToasts } from './ToastProvider'

const defaultErrorMessage = 'An error occurred. Please try again later.'

/**
 * Component to surface toast notifications that originate from the server (via js-flash-alerts),
 * or from a redux action (e.g. dispatched from thunks, which don't have access to react contexts
 * and therefore can't add/remove toast notifications like components in the React tree can).
 */
const ToastNotifier = (): null => {
  const { addToast } = useToasts()

  const notification = useReduxSelector((state) => state.notification)

  useEffect(() => {
    try {
      JSON.parse(
        document?.querySelector('.js-flash-alerts')?.innerHTML,
      )?.forEach(([style, message]: [string, string]) => {
        addToast(message || defaultErrorMessage, {
          appearance: style === 'error' ? 'error' : 'success',
        })
      })
    } catch (error) {
      // This is a legacy way of surfacing notifications. A JSON file describing notifications
      // is embedded inside an HTML element by the server, and then retrieved and parsed by the client.
      // For now just ignoring the error if unable to parse the JSON.
      // In future this ought to be removed completely.
    }
  }, [])

  useEffect(() => {
    if (notification.open) {
      addToast(notification.message || defaultErrorMessage, {
        appearance: notification.style || 'success',
      })
    }
  }, [notification])

  return null
}

export default withRenderClientsideOnly(ToastNotifier)
